import AxiosProvider from '@/app/utils/api/axios-provider';

export default {
  forceLogout(clientId: number) {
    return AxiosProvider.amsApiClient.get(`/${clientId}/forceLogout`);
  },
};
